import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../StoreSelector.css';
import './NewStoreSelector.css';
import Segment from 'semantic-ui-react/dist/es/elements/Segment';
import Header from 'semantic-ui-react/dist/es/elements/Header';

import 'semantic-ui-css/components/header.min.css';
import 'semantic-ui-css/components/segment.min.css';
import StoreSelectorMenuItem from './StoreSelectorMenuItem';
import CurrentStoreMenuItem from './CurrentStoreMenuItem';
import { Tab } from 'semantic-ui-react';
import CurrentStoreFloorMenuItem from './CurrentStoreFloorMenuItem';
import { getStoreId } from '../../../../utils/StoreConfigManager.js';

const storeId = getStoreId();

export const singaporeStoreId = '620d286ec38181ef4d34fbfb';

/**
    Default store selector used by all new stores, as long as they follow the pattern of only linking scenes insteda of
    linking stores
 */
class StoreSelectorMenu extends Component {
    constructor(props) {
        super(props);
        this.hide = this.hide.bind(this);
        this.renderMenuItems = this.renderMenuItems.bind(this);
    }

    hide() {
        this.setState({ visible: false });
    }

    renderMenuItems() {
        const { linkedStores, currentStoreIndex, sceneIdNameDict, menuTextFontStyle, closeMenu } = this.props;
        return (
            <Segment.Group>
                {linkedStores.map((store, index) => {
                    // let MenuItem = currentStoreIndex === index ? CurrentStoreMenuItem : StoreSelectorMenuItem;
                    const MenuItem = CurrentStoreMenuItem;
                    return <MenuItem
                        key={index}
                        store={store}
                        menuTextFontStyle={menuTextFontStyle}
                        sceneIdNameDict={sceneIdNameDict}
                        closeMenu={closeMenu}
                    />
                })}
            </Segment.Group>
        );
    }

    renderFloorMenuItems() {
        const { sceneIdNameDict, menuTextFontStyle, closeMenu} = this.props;
        const MenuItem = CurrentStoreFloorMenuItem;
        return (
            <Segment.Group>
                <MenuItem
                    menuTextFontStyle={menuTextFontStyle}
                    sceneIdNameDict={sceneIdNameDict}
                    closeMenu={closeMenu}
                    itemType="floor"
                />
            </Segment.Group>
        );

    }

    render() {
        const { showMenu, menuTitleFontStyle, selectorTitle } = this.props;
        if (!showMenu) {
            return (<div />);
        }
        return (
            <React.Fragment>
                <div id='store-selector-arrow' style={{marginLeft: 'auto', marginRight: '10px'}}/>
                <div id='storeSelectorMenu' style={{ backgroundColor: '#E1E1E5' }} className={'store-menu-tab'}>
                    <Tab panes={[
                        {
                            menuItem: storeId !== singaporeStoreId && '57TH STREET',
                            render: () =>
                                <Tab.Pane className='menu-tab'>
                                    {this.renderMenuItems()}
                                </Tab.Pane>
                        },
                        storeId !== singaporeStoreId && 
                        {
                            menuItem: 'FLOOR PLAN',
                            render: () =>
                                <Tab.Pane className='menu-tab'>
                                    {this.renderFloorMenuItems()}
                                </Tab.Pane>
                        }
                    ]} />

                </div>
            </React.Fragment>
        );
    }
}

StoreSelectorMenu.propTypes = {
    showMenu: PropTypes.bool,
    linkedStores: PropTypes.array,
    currentStoreIndex: PropTypes.number,
    menuTextFontStyle: PropTypes.object,
    menuTitleFontStyle: PropTypes.object,
    menuTitle: PropTypes.string,
    sceneIdNameDict: PropTypes.object,
    closeMenu: PropTypes.func
};

export default StoreSelectorMenu;
